/*
  COPY THESE INSTRUCTIONS TO ALL NEW LANGUAGE CONFIG FILES (FOR EASY ACCESS)

Three files need their import statements altered for a Language Switch
1. App.scss - handles all styling changes
2. App.js - Enabling contents to change throughout the app to fit the Language
3. Store/firestore.js - Enables data from correct firestore database
  */

const tabNameWelcome = "Ookoowayi";
const tabNameDictionary = "Sináákia’tsis";
const firebaseConfig = {
  apiKey: "AIzaSyCxwklDJOSPpQoIknWonYMtvQnrUJ0nMAM",
  authDomain: "blackfoot-426cd.firebaseapp.com",
  databaseURL: "https://blackfoot-426cd.firebaseio.com",
  projectId: "blackfoot-426cd",
  storageBucket: "blackfootmedia",
  messagingSenderId: "699466291137",
  appId: "1:699466291137:web:a2c3cac82e7fad6ade4140",
  measurementId: "G-CGRNG1WFM4",
};

const linkArray = [
  {
    link: false,
    text: "Indian Education for All",
    activeName: "bcc",
    navText: "http://blackfootkeystone.com/IEFA/",
    navType: "external",
  },
  {
    link: false,
    text: "Blackfeet Tour Map",
    activeName: "map",
    navText: "http://blackfootkeystone.com/BlackfeetNationTour/",
    navType: "external",
  },
];

const welcomeEngArray = [
  "Hello, everyone.",
  "I am glad to see you all.",
  "I am happy that you have all come here.",
  "It's a happy day",
  "To try to speak Blackfoot.",
];

const welcomeLangArray = [
  { text: "Oki kanaitapi", audio: "hello_everyone.mp3" },
  { text: "Ihsukapi kitsinohtsi", audio: "glad_to_see_you_all.mp3" },
  {
    text: "Tsiikohtaahsi'tsihp iihtootaaatsiiyo'p",
    audio: "i_am_happy_you_all_come_here.mp3",
  },
  { text: "Iitamiksistikoo", audio: "its_happy_day.mp3" },
  { text: "Stamssaakiitsi'poyit", audio: "try_to_speak_blackfoot.mp3" },
];

const welcomeLogoArray = [
  "logo-nta",
  "logo-pikani",
  "logo-bfcc",
  "logo-montana-seal",
];

const welcomeMessageArray = [
  "Developed by Native Teaching Aids, in conjunction with the Blackfoot Community College.",
  "This project was funded by the State of Montana through the Montana Indian Language Preservation Program.",
];

const config = {
  linkArray: linkArray,
  engArray: welcomeEngArray,
  langArray: welcomeLangArray,
  logoArray: welcomeLogoArray,
  messageArray: welcomeMessageArray,
  tabNameWelcome: tabNameWelcome,
  tabNameDictionary: tabNameDictionary,
  firebaseConfig: firebaseConfig,
};

export default config;
export { linkArray, welcomeEngArray, welcomeLangArray, firebaseConfig };
